// src/components/Information.jsx
import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider,
  Box,
} from '@mui/material';
import { styled } from '@mui/material/styles'; // <--- IMPORT CORRECTO
import RoomIcon from '@mui/icons-material/Room';
import PhoneIcon from '@mui/icons-material/Phone';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

/* ===== Estilos pro y seguros ===== */
const RootContainer = styled(Container)(({ theme }) => ({
  flexGrow: 1,
  marginTop: (theme?.spacing && theme.spacing(4)) || 32,
  marginBottom: (theme?.spacing && theme.spacing(6)) || 48,
}));

const TitleTypography = styled(Typography)(({ theme }) => ({
  marginBottom: (theme?.spacing && theme.spacing(3)) || 24,
  fontWeight: 900,
  letterSpacing: '.02em',
}));

const Card = styled(Paper)(({ theme }) => ({
  borderRadius: 16,
  padding: (theme?.spacing && theme.spacing(3)) || 24,
  background:
    'linear-gradient(180deg, rgba(255,255,255,.96) 0%, rgba(255,255,255,.92) 100%)',
  border: '1px solid rgba(0,0,0,.06)',
  boxShadow:
    '0 1px 0 rgba(255,255,255,.8) inset, 0 14px 26px rgba(0,0,0,.12), 0 60px 120px rgba(0,0,0,.06)',
}));

const Row = styled(ListItem)(({ theme }) => ({
  alignItems: 'flex-start',
  paddingLeft: 0,
  paddingRight: 0,
  gap: (theme?.spacing && theme.spacing(2)) || 16,
}));

const IconBadge = styled(Box)(({ theme }) => ({
  minWidth: 52,
  minHeight: 52,
  borderRadius: 12,
  display: 'grid',
  placeItems: 'center',
  background:
    'linear-gradient(180deg, rgba(218,165,32,.18) 0%, rgba(218,165,32,.06) 100%)',
  border: '1px solid rgba(218,165,32,.35)',
  boxShadow:
    'inset 0 1px 0 rgba(255,255,255,.5), 0 8px 18px rgba(218,165,32,.18)',
}));

const Primary = styled(Typography)({
  fontWeight: 800,
  letterSpacing: '.04em',
});

const Secondary = styled(Typography)(({ theme }) => ({
  color: (theme && theme.palette && theme.palette.text && theme.palette.text.secondary) || 'rgba(17,17,17,.72)',
  letterSpacing: '.02em',
}));

const AccentDivider = styled(Divider)({
  margin: '10px 0 4px',
  borderColor: 'rgba(0,0,0,.06)',
});

/* ===== Componente ===== */
const Information = () => {
  return (
    <RootContainer maxWidth="lg">
      <TitleTypography
        className="custom-title"
        variant="h4"
        align="center"
        sx={{ color: '#111' }}
      >
        Información de Contacto
      </TitleTypography>

      <Grid container justifyContent="center">
        <Grid item xs={12} md={8} lg={7}>
          <Card elevation={0}>
            <List disablePadding>
              {/* Dirección */}
              <Row>
                <IconBadge>
                  <RoomIcon sx={{ color: '#DAA520' }} />
                </IconBadge>
                <ListItemText
                  primary={
                    <Primary className="custom-title" variant="h6">
                      Dirección
                    </Primary>
                  }
                  secondary={<Secondary variant="body1">Buenos Aires</Secondary>}
                />
              </Row>

              <AccentDivider />

              {/* Teléfono */}
              <Row>
                <IconBadge>
                  <PhoneIcon sx={{ color: '#DAA520' }} />
                </IconBadge>
                <ListItemText
                  primary={
                    <Primary className="custom-title" variant="h6">
                      Teléfono
                    </Primary>
                  }
                  secondary={<Secondary variant="body1">011 5027 9026</Secondary>}
                />
              </Row>

              <AccentDivider />

              {/* Horario */}
              <Row sx={{ mb: 0 }}>
                <IconBadge>
                  <AccessTimeIcon sx={{ color: '#DAA520' }} />
                </IconBadge>
                <ListItemText
                  primary={
                    <Primary className="custom-title" variant="h6">
                      Horario de Atención
                    </Primary>
                  }
                  secondary={
                    <Secondary variant="body1">
                      Lunes a viernes de 8:00 a 20:00 hs.
                    </Secondary>
                  }
                />
              </Row>
            </List>
          </Card>
        </Grid>
      </Grid>
    </RootContainer>
  );
};

export default Information;
